export function animationOnScroll() {
    let $window = $(window);
    let $items = $(".has-animation");

    $window.on("scroll load", function () {
        $items.each(function (i, it) {
            if ($window.scrollTop() > $(it).offset().top - $window.height() * 0.88) {
                $(it).addClass("animated");
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/animationOnScroll.js